export default {
  STATUS: [
    { KEY: 0, VALUE: 'ATIVO' },
    { KEY: 1, VALUE: 'INATIVO' },
    { KEY: 2, VALUE: 'EXPIRADO' },
  ],
  IMC_TYPES: [
    { KEY: 'THINNESS', VALUE: '0 magreza - menor que 18,5' },
    { KEY: 'NORMAL', VALUE: 'I normal - entre 18,5 e 24,9' },
    { KEY: 'OVERWEIGHT', VALUE: 'II sobrepeso - entre 25 e 29,9' },
    { KEY: 'OBESITY', VALUE: 'III obesidade - entre 30 e 39,9' },
    { KEY: 'SERIOUS_OBESITY', VALUE: 'IV obesidade grave - maior que 40' },
  ],
  GENDER_TYPES: [
    { KEY: 'WOMAN', VALUE: 'Mulher' },
    { KEY: 'MAN', VALUE: 'Homem' },
    { KEY: 'TRANSVESTITE', VALUE: 'Travesti' },
    { KEY: 'NON_BINARY', VALUE: 'Não Binário' },
    { KEY: 'OTHERS', VALUE: 'Outro' },
  ],
  ETHNIC_TYPES: [
    { KEY: 'WHITE', VALUE: 'Branca' },
    { KEY: 'BROWN', VALUE: 'Parda' },
    { KEY: 'BLACK', VALUE: 'Preta' },
    { KEY: 'YELLOW', VALUE: 'Amarela' },
    { KEY: 'INDIGENOUS', VALUE: 'Indígena' },
  ],
  COMPANION_TYPES: [
    { KEY: 'OPTIONAL', VALUE: 'Opcional' },
    { KEY: 'REQUIRED', VALUE: 'Obrigatório' },
  ],
};

const CONST_PROFILES = {
  STATUS: {
    ACTIVE: { KEY: 1, VALUE: 'ATIVO' },
    INACTIVE: { KEY: 0, VALUE: 'INATIVO' },
  },
  IMC_TYPES: {
    THINNESS: { KEY: 'THINNESS', VALUE: '0 magreza - menor que 18,5' },
    NORMAL: { KEY: 'NORMAL', VALUE: 'I normal - entre 18,5 e 24,9' },
    OVERWEIGHT: { KEY: 'OVERWEIGHT', VALUE: 'II sobrepeso - entre 25 e 29,9' },
    OBESITY: { KEY: 'OBESITY', VALUE: 'III obesidade - entre 30 e 39,9' },
    SERIOUS_OBESITY: {
      KEY: 'SERIOUS_OBESITY',
      VALUE: 'IV obesidade grave - maior que 40',
    },
  },
  GENDER_TYPES: {
    WOMAN: { KEY: 'WOMAN', VALUE: 'Mulher' },
    MAN: { KEY: 'MAN', VALUE: 'Homem' },
    TRANSVESTITE: { KEY: 'TRANSVESTITE', VALUE: 'Travesti' },
    NON_BINARY: { KEY: 'NON_BINARY', VALUE: 'Não Binário' },
    OTHERS: { KEY: 'OTHERS', VALUE: 'Outro' },
  },
  ETHNIC_TYPES: {
    WHITE: { KEY: 'WHITE', VALUE: 'Branca' },
    BROWN: { KEY: 'BROWN', VALUE: 'Parda' },
    BLACK: { KEY: 'BLACK', VALUE: 'Preta' },
    YELLOW: { KEY: 'YELLOW', VALUE: 'Amarela' },
    INDIGENOUS: { KEY: 'INDIGENOUS', VALUE: 'Indígena' },
  },
  COMPANION_TYPES: {
    OPTIONAL: { KEY: 'OPTIONAL', VALUE: 'Opcional' },
    REQUIRED: { KEY: 'REQUIRED', VALUE: 'Obrigatório' },
    SAME: {
      KEY: 'SAME',
      VALUE: 'Através da mesma mídia do beneficiário.',
    },
    OTHER: {
      KEY: 'OTHER',
      VALUE: 'Através de mídias pessoais distintas',
    },
  },
  PERIODS: [
    { KEY: 0, VALUE: 'Diariamente' },
    { KEY: 1, VALUE: 'Semanalmente' },
    { KEY: 2, VALUE: 'Mensalmente' },
    { KEY: 3, VALUE: 'Anualmente' },
    { KEY: 4, VALUE: 'Única vez' },
  ],
  WALLET_CHARGE_TIMING_TYPES: [
    { KEY: 'CONTINUOUS_TIMING', VALUE: 0 },
    { KEY: 'DEFINED_TIMING', VALUE: 1 },
  ],
  TIMINGS_DEFINED: [
    {
      KEY: 0,
      VALUE:
        'Se a frquência escolhida for "diária" o crédito vale das 00:00 às 23:59 de cada dia.',
    },
    {
      KEY: 1,
      VALUE:
        'Se a frequência escolhida for "semanal" o crédito expirará às 23:59 do último dia de cada semana.',
    },
    {
      KEY: 2,
      VALUE:
        'Se a frequência escolhida for "mensal" o crédito expirará às 23:59 do último dia de cada mês.',
    },
    {
      KEY: 3,
      VALUE:
        'Se a frequência escolhida for "anual" o crédito expirará às 23:59 do último dia de cada ano.',
    },
    { KEY: 4, VALUE: 'Única vez' },
  ],
  TIMINGS_UNDEFINED: [
    {
      KEY: 0,
      VALUE:
        'Se a frequência escolhida for "diária" o crédito expirará em 24 horas após o momento da concessão.',
    },
    {
      KEY: 1,
      VALUE:
        'Se a frequência escolhida for "semanal" o crédito expirará em 7 dias após o momento da concessão.',
    },
    {
      KEY: 2,
      VALUE:
        'Se a frequência escolhida for "mensal" o crédito expirará em 30 dias após o momento da concessão.',
    },
    {
      KEY: 3,
      VALUE:
        'Se a frequência escolhida for "anual" o crédito expirará em 365 dias após o momento da concessão.',
    },
    { KEY: 4, VALUE: 'Única vez' },
  ],
};

const PROFILE_TYPES = [
  { KEY: 0, VALUE: 'COMUM' },
  { KEY: 1, VALUE: 'ESTUDANTE' },
  { KEY: 2, VALUE: 'ACOMPANHANTE' },
  { KEY: 3, VALUE: 'VT' },
  { KEY: 4, VALUE: 'CONTINGÊNCIA' },
];
const PROFILE_ESTUDANTE_TYPE = 1;

const PROFILE_TYPES_REQUEST = [
  { KEY: 'DEFAULT', VALUE: 0 },
  { KEY: 'STUDENT', VALUE: 1 },
  { KEY: 'COMPANION', VALUE: 2 },
  { KEY: 'VT', VALUE: 3 },
];

const RESOURCE_TYPES_ALLOWED = [
  { KEY: 0, VALUE: 'COAUTHORSHIP_DEVICE' },
  { KEY: 1, VALUE: 'ALLOWED_DEVICE' },
  { KEY: 2, VALUE: 'COMPANION' },
  { KEY: 3, VALUE: 'CEPS' },
  { KEY: 4, VALUE: 'CIDS' },
  { KEY: 5, VALUE: 'HEALTH_DECLARATION' },
  { KEY: 6, VALUE: 'DOCUMENT_RG' },
  { KEY: 7, VALUE: 'DOCUMENT_CPF' },
  { KEY: 8, VALUE: 'PICTURE_DOCUMENT' },
  { KEY: 9, VALUE: 'USER_PHOTO' },
  { KEY: 10, VALUE: 'MOTHER_NAME' },
  { KEY: 11, VALUE: 'FATHER_NAME' },
  { KEY: 12, VALUE: 'MOTHER_DOCUMENT' },
  { KEY: 13, VALUE: 'FATHER_DOCUMENT' },
  { KEY: 14, VALUE: 'GENRES' },
  { KEY: 15, VALUE: 'ETHNICITIES' },
  { KEY: 16, VALUE: 'BIRTHDATE' },
  { KEY: 17, VALUE: 'EMAIL' },
  { KEY: 18, VALUE: 'PHONE' },
  { KEY: 19, VALUE: 'EMPLOYER' },
  { KEY: 20, VALUE: 'EMPLOYEE_FUNCTION' },
  { KEY: 21, VALUE: 'EMPLOYEE_ENTER_DATE' },
  { KEY: 22, VALUE: 'EDUCATIONAL' },
  { KEY: 23, VALUE: 'EDUCATIONAL_DOCUMENT' },
  { KEY: 24, VALUE: 'INSS_DOCUMENT' },
  { KEY: 25, VALUE: 'SEDS_DOCUMENT' },
  { KEY: 26, VALUE: 'NIS_DOCUMENT' },
  { KEY: 27, VALUE: 'GESTATION' },
  { KEY: 28, VALUE: 'IMC' },
  { KEY: 29, VALUE: 'FULLNAME' },
  { KEY: 30, VALUE: 'ALLOWED_LINES' },
  { KEY: 31, VALUE: 'ALLOWED_DAYS' },
  { KEY: 32, VALUE: 'PERIODS' },
];
const RESOURCE_TYPES_ENUM = {
  BIRTHDATE: 'BIRTHDATE',
};

export {
  CONST_PROFILES,
  PROFILE_TYPES,
  PROFILE_TYPES_REQUEST,
  RESOURCE_TYPES_ALLOWED,
  PROFILE_ESTUDANTE_TYPE,
  RESOURCE_TYPES_ENUM,
};
